import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Dispatch } from 'redux';
import moment from 'moment';
import { inspectorSelectors } from 'redux/app/vessel/inspector';
import { vesselSelectors } from 'redux/app/vessel';
import { IStore } from 'redux/store';

type OwnProps = {
	vesselId: string;
    selectedDate?: string;
};
type DeckEPSCoverPageProps = PropsFromRedux & OwnProps;
function DeckEPSCoverPage(props: DeckEPSCoverPageProps) {
    const { vesselInfo, selectedDate } = props;
    const deckLogData = {
        firstPage: {
            mt: vesselInfo?.vesselName ?? '',
            callSign: vesselInfo?.callSign ?? '',
            officialNo: vesselInfo?.imoNumber ?? '',
            periodFrom:
                (selectedDate && moment(selectedDate).format('DD-MM-yyyy')) ??
                '',
            periodTo:
                (selectedDate && moment(selectedDate).format('DD-MM-yyyy')) ??
                '',
        },
    };

    const { firstPage } = deckLogData;
    const { mt, callSign, officialNo, periodFrom, periodTo } = firstPage;
    return (
        <>
            {/* First page */}
            <div className="flex flex-col justify-between py-4 px-8 mb-2 print-page-break">
                <div className="font-medium text-center text-xl my-24 mx-0">
                    <h2 className="uppercase text-2xl">DECK LOG BOOK</h2>
                </div>
                <div className="flex justify-center mt-8 mb-32">
                    <div className="w-2/3 mt-2.5">
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Vessel Name:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {mt}
                            </p>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Call Sign:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {callSign}
                            </p>
                        </div>

                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Official No:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                {officialNo}
                            </p>
                        </div>
                        <div
                            className="flex justify-between items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <div
                                style={{ width: '54%' }}
                                className="flex items-center  mb-2"
                            >
                                <p className="mr-2 min-w-fit">Period From :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                    {periodFrom}
                                </p>
                            </div>
                            <div
                                style={{ width: '45%' }}
                                className="flex items-center mb-2"
                            >
                                <p className="mr-2 min-w-fit">To :</p>
                                <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end text-sm">
                                    {periodTo}
                                </p>
                            </div>
                        </div>
                        <div
                            className="flex items-center mb-4"
                            style={{ fontSize: '1.125rem' }}
                        >
                            <p className="mr-2 min-w-fit mb-0">Working language of the ship:</p>
                            <p className="inline-block px-3 text-[#808080] border-b border-dashed border-[#808080] w-full mb-0 self-end">
                                English
                            </p>
                        </div>
                    </div>
                </div>
            </div>
            {/* Second page */}
            <div className="flex flex-col justify-between py-4 pt-0 px-8 mb-2 text-left">
                <h2 className="uppercase text-2xl font-semibold text-center print:py-4">
                    Instructions
                </h2>

                <ol className="list-decimal ml-4">
                    <li className="my-2 mx-0">
                        A proper log shall be kept aboard every vessel in
                        service.
                    </li>
                    <li className="my-2 mx-0">
                        Time shall be record in the 24-hour lock system, and
                        always as actually indicated by the bridge clock.
                    </li>
                    <li className="my-2 mx-0">
                        The log shall be a reasonably comprehensive record of
                        activities on board the ship.
                    </li>
                    <li className="my-2 mx-0">
                        It is not necessary to confine the ship's daily activity
                        to one page. As many pages as are necessary to
                        completely record the events may be used.
                    </li>
                    <li className="my-2 mx-0">
                        Entries shall be made promptly.
                    </li>
                    <li className="my-2 mx-0">
                        All entries shall be made in ink.
                    </li>
                    <li className="my-2 mx-0">
                        The officer making an entry shall append his signature
                        to it.
                    </li>
                    <li className="my-2 mx-0">
                        No erasures shall be made, errors shall be crossed out
                        neatly with a single line and initialed.
                    </li>
                    <li className="my-2 mx-0">
                        The master and chief officer shall verify and sign the
                        logbook daily.
                    </li>
                    <li className="my-2 mx-0">
                        The block-form-spaces are self-explanatory and should be
                        adhered to and filled out as completely as is feasible.
                    </li>
                </ol>
                <h3 className="text-lg font-semibold print:pt-6 print:pb-2">
                    The following entries shall be written in the REMARKS and
                    ADDITIONAL REMARKS sections:
                </h3>
                <ol className="list-decimal ml-4">
                    <li className="my-2 mx-0">
                        Conduct of tests before port arrival and departure of
                        navigation and communication equipment, navigation
                        lights, whistles, engine telegraph, brigde-maneuvering
                        control, steering gear.
                    </li>
                    <li className="my-2 mx-0">
                        Synchronisation of master gyro, repeaters and course
                        recorder prior getting underway.
                    </li>
                    <li className="my-2 mx-0">Synchronisation of clocks.</li>
                    <li className="my-2 mx-0">
                        Monitoring drift of vessel, movement of vessels in the
                        vicinity while waiting for pilot.
                    </li>
                    <li className="my-2 mx-0">
                        Names of pilots and time when pilotage commenced and
                        ended.
                    </li>
                    <li className="my-2 mx-0">
                        Position by bearings at anchorages, the anchor in use,
                        the length of chain paid out and the depth of Water.
                    </li>
                    <li className="my-2 mx-0">
                        Names of tugs rendering assistance, nature of
                        assistance, time and place
                    </li>
                    <li className="my-2 mx-0">
                        Draft and density of sea water on arrival and departure
                        from each port, after cargo, ballast, bunker Operations.
                    </li>
                    <li className="my-2 mx-0">
                        Time when Free Pratique is granted.
                    </li>
                    <li className="my-2 mx-0">
                        Time and description of barges or vessels coming
                        alongside or leaving the shipside.
                    </li>
                    <li className="my-2 mx-0">
                        Prior commencing cargo operations, integrity of cargo
                        pumproom/engine room gas seal to be verified as
                        applicable.
                    </li>
                    <li className="my-2 mx-0">
                        Details of main features of cargo and ballast
                        operations.
                    </li>
                    <li className="my-2 mx-0">
                        Delays to the vessel at sea or in port and causes
                        thereof.
                    </li>
                    <li className="my-2 mx-0">
                        Embarkation/disembarkation, hospitalisation or desertion
                        of member of the crew
                    </li>
                    <li className="my-2 mx-0">Shipboard inspections.</li>
                    <li className="my-2 mx-0">Tests of emergency equipment.</li>
                    <li className="my-2 mx-0">
                        Vessel inspected and secured for sea prior every
                        departure from port.
                    </li>
                    <li className="my-2 mx-0 print:pt-4">
                        Securing of anchors prior commencement of voyage.
                    </li>
                    <li className="my-2 mx-0">
                        Results of inspection to ensure all watertight
                        compartment are secured prior navigating in restricted
                        waters, or at port arrivals and departures.
                    </li>
                    <li className="my-2 mx-0">
                        Record of the start and stop of all diving operations.
                    </li>
                    <li className="my-2 mx-0">
                        Starting and stopping of gyro compass, changing over of
                        the gyro compass, disabling of fire detection system.
                    </li>
                    <li className="my-2 mx-0">
                        Opening and closing of articles of agreement and
                        official log book.
                    </li>
                    <li className="my-2 mx-0">
                        All completed training and emergency drills.
                    </li>
                    <li className="my-2 mx-0">
                        Particulars of an accident involving personal or
                        property of or on the vessel or the vessel itself.
                    </li>
                    <li className="my-2 mx-0">
                        Particulars of any damage sustained or caused by the
                        vessel or cargo.
                    </li>
                    <li className="my-2 mx-0">
                        Particulars of any salvage services rendered or
                        received.
                    </li>
                    <li className="my-2 mx-0">
                        Particulars of any major vessel repairs.
                    </li>
                    <li className="my-2 mx-0">Time of COP, EOP, SBE, FEW.</li>
                    <li className="my-2 mx-0">
                        Data pertaining to navigation i.e. time, bearing,
                        distance off light houses, buoys, beacons etc.
                    </li>
                    <li className="my-2 mx-0">
                        Effect of wind and sea on the vessel, i.e. shipping
                        water/spray, rolling and pitching.
                    </li>
                    <li className="my-2 mx-0">
                        Particulars of any deviation from the voyage and reasons
                        thereof.
                    </li>
                    <li className="my-2 mx-0">
                        Atleast one position each watch when the vessel is
                        underway.
                    </li>
                    <li className="my-2 mx-0">Compass error verification.</li>
                    <li className="my-2 mx-0">
                        Checking of gyro and magnetic compasses at each watch
                        changeover, comparison of compass during the watch.
                    </li>
                    <li className="my-2 mx-0">
                        All course and speed alterations, with vessel's position
                        and time of alteration.
                    </li>
                    <li className="my-2 mx-0">
                        Course to steer, gyro and,magnetic courses after each
                        alteration and relevant errors.
                    </li>
                    <li className="my-2 mx-0">
                        Check of operational status of radar and position fixing
                        systems and equipment.
                    </li>
                    <li className="my-2 mx-0">
                        Effectiveness of the radars as measured by the
                        performance monitors, to be recorded at the end of each
                        watch whenever the radars are operational in radar log
                        book or deck log book as applicable. A numeric,
                        percentage or graphical value should also be recorded.
                    </li>
                    <li className="my-2 mx-0">
                        All changes of conn during navigation.
                    </li>
                    <li className="my-2 mx-0">
                        Changes of watch condition and reason.
                    </li>
                    <li className="my-2 mx-0">
                        Changes of zone time - advancing or retarding of clocks.
                    </li>
                    <li className="my-2 mx-0">
                        Change over of steering mode from hand to auto or
                        vice-versa.
                    </li>
                    <li className="my-2 mx-0">
                        Results of all steering gear tests.
                    </li>
                    <li className="my-2 mx-0">
                        Statement that a navigation meeting held prior departure
                        port, prior entry into a restricted area.
                    </li>
                    <li className="my-2 mx-0">
                        In deteriorating visibility, compliance with restricted
                        visibility checklist.
                    </li>
                    <li className="my-2 mx-0">
                        Restricted visibility watch condition set.
                    </li>
                    <li className="my-2 mx-0">
                        Vessel property rigged for heavy weather when bad
                        weather is anticipated.
                    </li>
                    <li className="my-2 mx-0 print:pt-4">
                        Check of anchor securing arrangements when heavy weather
                        is anticipated.
                    </li>
                    <li className="my-2 mx-0">
                        Check of anchor securing arrangements at least every 3
                        days during prolonged periods of heavy weather.
                    </li>
                    <li className="my-2 mx-0">
                        If no deadman alarm fitted in engine room, contact every
                        15 minutes between duty engineer in engine room and
                        bridge officer when vessel operating in UMS mode.
                    </li>
                    <li className="my-2 mx-0">
                        The time of manning and unmanning of the E/Rm during UMS
                        operation.
                    </li>
                    <li className="my-2 mx-0">Removal of anchor lashings.</li>
                    <li className="my-2 mx-0">
                        Anti-piracy precautions taken.
                    </li>
                    <li className="my-2 mx-0">
                        Where applicable prior arrival port, operation of high
                        velocity vents to prove free action.
                    </li>
                    <li className="my-2 mx-0">
                        Where applicable conduct of an STS drill at least 24
                        hours prior arrival in port for STS operations.
                    </li>
                    <li className="my-2 mx-0">
                        Where applicable pressure test of COW pipelines prior
                        arrival discharge port.
                    </li>
                    <li className="my-2 mx-0">
                        Draft before and after operating in ultra-light ballast
                        mode.
                    </li>
                    <li className="my-2 mx-0">
                        Practical ship handling training provided by the master
                        to deck officers.
                    </li>
                    <li className="my-2 mx-0">
                        Adjustment of magnetic compass and preparation of
                        deviation table.
                    </li>
                    <li className="my-2 mx-0">
                        Compliance with all relevant navigation checklists as
                        per chapter 6 of standing instructions.
                    </li>
                </ol>
            </div>
        </>
    );
}

function mapStateToProps(store: IStore, ownProps: OwnProps) {
    const inspectorStore = inspectorSelectors._getStore(store);
	const vesselStore = vesselSelectors._getStore(store);
	const vesselInfo = vesselSelectors.getVesselById(
		ownProps.vesselId,
		vesselSelectors.getVessels(vesselStore)
	);
    const dateRange = inspectorSelectors.getDateRange(inspectorStore);

    return {
        vesselInfo,
        dateRange,
    };
}
function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps) {
    return {};
}
const reduxConnector = connect(mapStateToProps, mapDispatchToProps);
type PropsFromRedux = ConnectedProps<typeof reduxConnector>;
export default reduxConnector(DeckEPSCoverPage);
